import { render, staticRenderFns } from "./PiHoleTopQueriesV6.vue?vue&type=template&id=e8218338&scoped=true"
import script from "./PiHoleTopQueriesV6.vue?vue&type=script&lang=js"
export * from "./PiHoleTopQueriesV6.vue?vue&type=script&lang=js"
import style0 from "./PiHoleTopQueriesV6.vue?vue&type=style&index=0&id=e8218338&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8218338",
  null
  
)

export default component.exports